// Temporary state enum before they are generated by the API
var ReleaseDspStateEnum;
(function (ReleaseDspStateEnum) {
    // Live States
    ReleaseDspStateEnum["Released"] = "Released";
    // Inactive
    ReleaseDspStateEnum["NotSelected"] = "NotSelected";
    // Pending States
    ReleaseDspStateEnum["Selected"] = "Selected";
    ReleaseDspStateEnum["PendingRelease"] = "PendingRelease";
    ReleaseDspStateEnum["PendingSelfDspPause"] = "PendingSelfDspPause";
    ReleaseDspStateEnum["PendingSelfProductPause"] = "PendingSelfProductPause";
    ReleaseDspStateEnum["PendingTakeDown"] = "PendingTakeDown";
    // Paused States
    ReleaseDspStateEnum["SelfDspPaused"] = "SelfDspPaused";
    ReleaseDspStateEnum["SelfProductPaused"] = "SelfProductPaused";
    // Denied
    ReleaseDspStateEnum["TakenDown"] = "TakenDown";
})(ReleaseDspStateEnum || (ReleaseDspStateEnum = {}));
var ReleaseDspStateLabelEnum;
(function (ReleaseDspStateLabelEnum) {
    ReleaseDspStateLabelEnum["Live"] = "Live";
    ReleaseDspStateLabelEnum["Inactive"] = "Inactive";
    ReleaseDspStateLabelEnum["Paused"] = "Paused";
    ReleaseDspStateLabelEnum["Pending"] = "Pending";
    ReleaseDspStateLabelEnum["Denied"] = "Denied";
})(ReleaseDspStateLabelEnum || (ReleaseDspStateLabelEnum = {}));

export { ReleaseDspStateEnum, ReleaseDspStateLabelEnum };
